import { TabList as tablist, Tabs as tabs, TabPanel as tabPanel } from 'react-tabs'
import styled from 'styled-components'
import { themeBreakPoints } from '@chegg-wt/core/theme/theme'
import { values } from '@chegg-wt/core/theme/sunkist/spacing'
import { Heading1, Heading2, Heading3 } from '@chegg-wt/core/theme/sunkist/typography'

export const Container = styled.div.attrs({
  role: 'region',
  'aria-label': 'Plus Tabs',
})`
  border: 1px solid ${({ theme }) => theme.Colors.forInterface.interfaceColor13};
  background-color: ${({ theme }) => theme.Colors.forInterface.interfaceColor11};
`

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  max-width: 880px;
  margin: auto;
  flex-direction: column;
  @media (max-width: ${({ theme }) => themeBreakPoints.small(theme)}) {
    align-items: flex-start;
  }
`

export const Header = styled.h1`
  ${Heading1};
  max-width: 647px;
  text-align: center;
  @media (max-width: ${({ theme }) => themeBreakPoints.small(theme)}) {
    margin-left: 35px;
    margin-right: 35px;
  }
`

export const SubHeader = styled.p`
  ${Heading2};
  max-width: 558px;
  margin-top: 20px;
  margin-bottom: 10px;
  @media (max-width: ${({ theme }) => themeBreakPoints.small(theme)}) {
    margin: 0 40px;
  }
`

export const Tabs = styled(tabs)`
  margin: 40px 0;
  @media (max-width: ${({ theme }) => themeBreakPoints.small(theme)}) {
    width: 100%;
    margin-bottom: 0;
  }
`

export const TabList = styled(tablist)`
  li {
    list-style-type: none;
  }
  border-bottom: 1px solid ${({ theme }) => theme.Colors.forInterface.interfaceColor13};
  @media (min-width: ${({ theme }) => themeBreakPoints.small(theme)}) {
    display: flex;
  }
`

export const TabPanel = styled(tabPanel)<{ selected: boolean }>`
  &[aria-hidden='true'] {
    display: none;
  }
`

export const StyledTabContents = styled.div<{ selected: boolean }>`
  ${Heading3};
  cursor: pointer;
  text-transform: capitalize;
  font-weight: ${({ selected }) => (selected ? 'bold' : 'normal')};
  @media (min-width: ${({ theme }) => themeBreakPoints.small(theme)}) {
    text-align: center;
    width: 230px;
    border-bottom: ${({ selected, theme }) =>
      selected ? `4px solid ${theme.Colors.forInterface.interfaceColor01}` : ''}};
    padding-bottom: ${values.xxsmall};
  }
`
